import { render, staticRenderFns } from "./ConnectionsProducer.vue?vue&type=template&id=90eaf48e&"
import script from "./ConnectionsProducer.vue?vue&type=script&lang=js&"
export * from "./ConnectionsProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports